/**
 * --------------------------------------------------------------------------
 * CoreUI Boostrap Admin Template config.js
 * Licensed under MIT (https://github.com/coreui/coreui-free-bootstrap-admin-template/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

(() => {
  const THEME = 'coreui-free-bootstrap-admin-template-theme'
  const urlParams = new URLSearchParams(window.location.href.split('?')[1])

  if (urlParams.get('theme') && ['auto', 'dark', 'light'].includes(urlParams.get('theme'))) {
    localStorage.setItem(THEME, urlParams.get('theme'))
  }
})()

// DataRapor Configuration
window.DataRaporConfig = {
  // Server-side DATARAPOR_OFFLINE_MODE is discovered below. The localStorage
  // mirror makes the setting effective synchronously on following page loads.
  offlineMode: localStorage.getItem('datarapor-offlineMode') === 'true',
  // Header navigation links configuration
  headerLinks: {
    enabled: true, // Set to false to hide all header links
    links: [
      { text: 'Anasayfa', url: 'index.html', icon: 'cil-home', enabled: true },
      { text: 'Raporlar', url: 'ChillerReport.html', icon: 'cil-chart-line', enabled: true }
    ]
  },
  
  // Default page to redirect when clicking "Anasayfa" and no last page is stored
  defaultPage: 'index.html',
  
  // Last page keys
  lastPageKey: 'datarapor-last-page',
  lastPageIdKey: 'datarapor-last-pageId',
  userDefaultPageIdKey: 'datarapor-user-default-pageId',

  // --- Environment Detection ---
  // If running on localhost, we can optionaly use local upload server
  // isLocal: ['localhost', '127.0.0.1'].includes(window.location.hostname),

  // Upload Server Configuration
  // Production: 'https://cdn-upload.datarapor.com'
  // Local: 'http://localhost:3002' (if you run cdn-upload-server locally)
  uploadServerUrl: 'https://cdn-upload.datarapor.com',
  
  // Api Key for Upload Server
  uploadApiKey: '607708cf66084344a296e167bbc83ea11724299b7b1170b262d552955ca1edc1',

  // CDN Configuration
  cdnEnabled: true,
  // Base URL for viewing images
  cdnBaseUrl: 'https://cdn.datarapor.com', 
  // Sub-folder for this project (e.g. 'akg/' or 'demo/')
  cdnLocation: 'akg/' 
};

// Synchronous CDN state check from localStorage (prevents race condition with async fetch)
if (localStorage.getItem('datarapor-cdnEnabled') === 'false') {
  window.DataRaporConfig.cdnEnabled = false;
}

if (window.DataRaporConfig.offlineMode) {
  window.DataRaporConfig.cdnEnabled = false;
  window.DataRaporConfig.cdnBaseUrl = window.location.origin;
  window.DataRaporConfig.uploadServerUrl = window.location.origin;
}

// Helper: Auto-switch to local dev if needed (Uncomment to enable auto-local)
/*
if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    console.log('[Config] Detected local environment, switching to local upload server...');
    window.DataRaporConfig.cdnBaseUrl = window.location.origin; 
    window.DataRaporConfig.cdnLocation = 'uploads'; 
}
*/

// Dynamic Config Discovery
// Fetches configuration from the server (which might be running in Docker with specific ENV vars)
(async () => {
    try {
        // Try fetching config from server
        // Use relative path to hit the same origin (CoreUI Server)
        const response = await fetch('/api/ui-config');
        if (response.ok) {
            const serverConfig = await response.json();

            window.DataRaporConfig.offlineMode = serverConfig.offlineMode === true;
            if (window.DataRaporConfig.offlineMode) {
              console.log('[Config] Server reported offline mode. Disabling public Internet dependencies.');
              window.DataRaporConfig.cdnEnabled = false;
              window.DataRaporConfig.cdnBaseUrl = window.location.origin;
              window.DataRaporConfig.uploadServerUrl = window.location.origin;
              localStorage.setItem('datarapor-offlineMode', 'true');
              localStorage.setItem('datarapor-cdnEnabled', 'false');
            } else {
              localStorage.removeItem('datarapor-offlineMode');
            }
            
            // If Server is configured for LOCAL uploads (via UPLOAD_PROVIDER=local ENV),
            // auto-configure the frontend to use local storage.
            if (serverConfig.uploadProvider === 'local') {
              console.log('[Config] Server reported local upload provider. Using same-origin upload proxy while keeping CDN reads.');
              window.DataRaporConfig.uploadServerUrl = window.location.origin;
            }

            // If server reports cdnEnabled: false (db-config CdnServerEnabled=false),
            // switch frontend to local image reading mode (/Files/...)
            if (serverConfig.cdnEnabled === false) {
              console.log('[Config] Server reported CDN disabled. Switching to local image paths.');
              window.DataRaporConfig.cdnEnabled = false;
              localStorage.setItem('datarapor-cdnEnabled', 'false');
            } else if (!window.DataRaporConfig.offlineMode) {
              localStorage.removeItem('datarapor-cdnEnabled');
            }

            if (serverConfig.cdnLocation && serverConfig.cdnLocation !== 'default') {
                // CDN mode: INSTANCE_NAME = CDN klasörü (akg, escon, vb.)
                window.DataRaporConfig.cdnLocation = serverConfig.cdnLocation + '/';
            }
        }
    } catch (e) {
        // Silent fail - use defaults
        console.debug('[Config] Could not fetch server config, using defaults.');
    }
})();

// Function to save current page and pageId
window.saveLastPage = function() {
  const currentPage = window.location.pathname.split('/').pop() || 'index.html'
  
  // Don't save login/register pages
  if (currentPage === 'login.html' || currentPage === 'register.html') {
    return
  }
  
  // Save page name
  localStorage.setItem(window.DataRaporConfig.lastPageKey, currentPage)
  
  // If we're on index.html with a pageId, save it as last viewed pageId
  if (currentPage === 'index.html') {
    const urlParams = new URLSearchParams(window.location.search)
    const pageId = urlParams.get('pageId')
    if (pageId) {
      localStorage.setItem(window.DataRaporConfig.lastPageIdKey, pageId)
      // If user doesn't have a default pageId yet, set this as default
      if (!localStorage.getItem(window.DataRaporConfig.userDefaultPageIdKey)) {
        localStorage.setItem(window.DataRaporConfig.userDefaultPageIdKey, pageId)
      }
    }
  }
}

// Function to get home page URL (index.html with optional pageId)
window.getHomePage = function() {
  // Try to get user's default pageId or last viewed pageId
  const defaultPageId = localStorage.getItem(window.DataRaporConfig.userDefaultPageIdKey)
  const lastPageId = localStorage.getItem(window.DataRaporConfig.lastPageIdKey)
  const pageId = defaultPageId || lastPageId
  
  // If we have a pageId, return index.html with pageId parameter
  if (pageId) {
    return `index.html?pageId=${pageId}`
  }
  
  // Otherwise just return index.html
  return 'index.html'
}

// Save current page on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.saveLastPage)
} else {
  window.saveLastPage()
}
